var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 58,
    viewBox: "0 0 239 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.977 14.2431V52.0972L203.846 14.2431H187.377H182.965H170.192V43.4748H187.377V19.9746L216.508 57.8489H232.977H237.399H238.719V14.2431H232.977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.49 14.2431H95.9041H75.0128H52.2983V19.9746H79.4348L97.5158 43.4748H118.397L100.316 19.9746L98.1 17.0938H128.49V19.9746H122.759V43.4748H128.49H165.841V32.2334H128.49V28.859H165.841V23.1174H128.621V19.9746H165.841V14.2431H129.457H128.49Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8089 17.4866V14.6964H8.09863L10.8888 17.4866H17.8089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0322 58H23.8325V33.2407L21.0624 36.0108L21.0322 58Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0933 53.7391L30.8835 50.9489V29.8562H28.0933V53.7391Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1543 46.6881L37.9445 43.8878V35.0942L35.1543 32.304V46.6881Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9445 31.1052L33.8851 23.0972H24.4971L13.981 33.6134V50.9388L16.7712 53.729V34.7718L25.6555 25.8874H32.7267L37.9445 31.1052Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8607 23.0972L6.92041 30.0476V43.918L9.73076 46.6881V31.1657L17.8093 23.0972H13.8607Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64918 39.6169V34.3084L0 36.9677L2.64918 39.6169Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74634 8.60229L20.7807 11.8156L26.9353 18.1514L25.5251 19.5717L29.4838 19.5314L30.8839 18.1514L24.9409 12.0271L29.6751 7.29281L22.3823 0H2.84082L8.49174 5.65092H4.79497L7.74634 8.60229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenLogo);
export default __webpack_public_path__ + "static/media/ten-logo.f9b62138f2efff436fa4caf62c141dca.svg";
export { ForwardRef as ReactComponent };